const clientDetailsMapper = (AllClientDetails) => {
    const result = {
        client: {},
        dpid: [],
        bankslist: [],
    };
    if (AllClientDetails) {
        const clientdetailslist = AllClientDetails.data.client;
        const details = {
            correspondenceAddress: clientdetailslist.correspondenceAdd,
            pdfFormPath: clientdetailslist.pdfFormPath,
            acCode: clientdetailslist.acCode,
            accName: clientdetailslist.acName,
            accType: clientdetailslist.acType,
            clientPlan: clientdetailslist.clientPlan,
            panNumber: clientdetailslist.pan,
            mobileNo: clientdetailslist.mobileNo,
            residenceAddress: clientdetailslist.residenceAdd,
            clientDob: clientdetailslist.birthDate,
            active: clientdetailslist.active,
            lob: clientdetailslist.lob,
            email: clientdetailslist.email,
        };
        result.client = details;
        const dpdata = AllClientDetails.data.dps.map((item) => {
            return {
                dpName: item.dp_Name,
                dpAcc: item.dp_AcNo,
                dpId: item.dp_Id,
                depositoryType: item.dp_Type,
                poa: item.poa,
                dpddpiSw: item.dpddpiSw,
                acCode: item.acCode,
            };
        });
        result.dpid = dpdata;
        const bankdata = AllClientDetails.data.banks.map((item) => {
            return {
                ifscCode: item.neftCode,
                bankName: item.bankName,
                bankAccNo: item.bankAccNo,
                acCode: item.acCode,
            };
        });
        result.bankslist = bankdata;
    }
    return result;
};
export default clientDetailsMapper;
